import * as React from 'react';
import { render } from 'react-dom';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, switchMap, take } from 'rxjs/operators';
import { WatermarkContainer } from '../components';
import {
  IDimension,
  IRelativeOffset,
  IScrollDimension,
  IScrollParent,
  ITargetScroll,
  ZIndex,
} from '../types';

export const renderWatermarkContainer = (
  sign: string,
  containerDiv: HTMLDivElement,
  correctionContainerPos$: Observable<IDimension>,
  relativeOffset$: Observable<IRelativeOffset>,
  scrollParentScroll$: Observable<ITargetScroll>,
  targetZIndex$: Observable<ZIndex>,
  scrollDimension$: Observable<IScrollDimension>,
  scrollParent$: Observable<IScrollParent>,
  scrollTargetAbsolutePosition$: Observable<ClientRect | DOMRect>,
  scrollParentRelativeOffset$: Observable<IRelativeOffset>,
  parentWindow: Window,
) => {
  const finalCorrectionContainerPos$ = scrollParent$.pipe(
    distinctUntilChanged((a, b) => {
      return (
        a.scrollParent === b.scrollParent &&
        a.hasScrollParent === b.hasScrollParent &&
        a.position === b.position
      );
    }),
    switchMap(({ hasScrollParent }) => {
      if (hasScrollParent) {
        return scrollTargetAbsolutePosition$;
      }
      return correctionContainerPos$;
    }),
  );
  const finalRelativeOffset$ = scrollParent$.pipe(
    distinctUntilChanged((a, b) => {
      return (
        a.scrollParent === b.scrollParent &&
        a.hasScrollParent === b.hasScrollParent &&
        a.position === b.position
      );
    }),
    switchMap(({ hasScrollParent, scrollParent }) => {
      if (hasScrollParent && scrollParent) {
        // when scroll parent is positioned, we put offset to 0,0 instead of using scrollParentRelativeOffset
        // e.g. test page quill editor
        if (parentWindow.getComputedStyle(scrollParent).position === 'static') {
          return scrollParentRelativeOffset$;
        }
        return of({ isRelative: false, left: 0, top: 0 });
      }
      return relativeOffset$;
    }),
  );
  scrollDimension$.pipe(take(1)).subscribe(({ scrollHeight, scrollWidth }) => {
    render(
      <WatermarkContainer
        style={{
          boxSizing: 'content-box',
          overflow: 'hidden',
          pointerEvents: 'none',
          position: 'relative',
        }}
        correctionContainerPos$={finalCorrectionContainerPos$}
        relativeOffset$={finalRelativeOffset$}
        scrollParentScroll$={scrollParentScroll$}
        targetZIndex$={targetZIndex$}
        scrollDimension$={scrollDimension$}
        initScrollHeight={scrollHeight * 5}
        initScrollWidth={scrollWidth * 5}
      />,
      containerDiv,
    );
  });
};
